import { localStore } from "./localStore";
/** Browser notifications round two (2026-10-18; brief rule 1, the red team's shapes): the one-time hint's pure part. A trigger (a ticket a
 *  colleague just assigned to the person, a mention, a direct message) shows the hint only in a browser that can subscribe, has not blocked
 *  pop-ups and holds no subscription in this workspace, for a person who is not away, once per browser and workspace. The memory lives in the
 *  browser's storage, read and written wrapped (the kit's storage rule): a private window or blocked site data never throws, it only forgets. */
/** the help article on browser notifications (served by the API like the legal pages), linked from the hint and the blocked Settings card */
export const HELP_ARTICLE = "/docs/browser-notifications";

export type HintFacts = { supported: boolean; permission: NotificationPermission | null; subscribed: boolean; away: boolean; seen: boolean };

/** whether a trigger shows the hint now */
export const pushHintDue = (f: HintFacts): boolean =>
  f.supported && f.permission !== null && f.permission !== "denied" && !f.subscribed && !f.away && !f.seen;

const KEY = "ob-push-hint:";
const pick = localStore;

/** has this browser shown the hint in this workspace (whatever the person did with it)? */
export function hintSeen(slug: string, storage?: Storage | null): boolean {
  try { return pick(storage)?.getItem(KEY + slug) != null; } catch { return false; }
}
/** remember that the hint was shown here; a storage that refuses only forgets */
export function rememberHintSeen(slug: string, storage?: Storage | null): void {
  try { pick(storage)?.setItem(KEY + slug, new Date().toISOString()); } catch { /* a private window: the hint may come once more */ }
}
